// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import { ImageFader } from "../../../components/image_fader/ImageFader";
import { ScrollIndicator } from "../../../components/scroll_indicator/ScrollIndicator";
import { ExpandButton } from "./expand_button/ExpandButton";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    ScrollIndicator,
    ExpandButton,
  },
})
export class StageBrancheModule extends ModuleBase {
  private isDropDownOpen = false;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  created() {
    this.$store.conversionWorld.loadBranchen(this.$store.page.page!.id);
  }

  get branchen() {
    return this.$store.conversionWorld.branchen;
  }

  get branche() {
    return this.branchen.find(
      (b) => b.slug === this.$store.page.page!.route_parameter["branchenId"]
    );
  }

  get backgroundImage() {
    if (this.branche) {
      return this.branche.images.bg_image_with_vehicle;
    }
    return "";
  }

  get question() {
    if (this.branche) {
      return this.branche.question;
    }

    return "";
  }

  get links() {
    if (this.branche) {
      let xs = this.branche.loesungen.slice(0, 5).map((l) => {
        return {
          href: l.link,
          text: l.alternative_title,
        };
      });

      xs.push({
        href: this.branche.link_softkonfigurator,
        text: this.instance["translation"]["expand_button_show_all"],
      });

      return xs;
    }

    return [];
  }
}
